import React, { createRef } from 'react';
import { NotificationMenu } from './menu/NotificationMenu';
import { NotificationContent } from './NotificationContent';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { Connect, PropsFromRedux } from './NotificationContainer';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { NavItemButton } from '../../components/item/NavItem';
import styles from './notification.module.scss';

type Props = {
  cancelHover: Function;
} & PropsFromRedux &
  UserContextType;

type State = {
  showNav: boolean;
};

const reloadNotificationsDelayMs = 300000;

export class RawNotification extends React.Component<Props, State> {
  state: State = {
    showNav: false,
  };

  notificationsLoadIntervalId: number | null = null;

  notificationRef = createRef<HTMLButtonElement>();

  loading = false;

  async componentDidMount() {
    const { onLoad, loggedIn } = this.props;
    try {
      await onLoad();
    } catch (error) {
      if (
        error.response &&
        error.response.status &&
        error.response.status === 403
      ) {
        window.location.href = '/';
      } else {
        throw error;
      }
    }

    if (loggedIn) {
      this.notificationsLoadIntervalId = window.setInterval(
        this.loadNotifications,
        reloadNotificationsDelayMs,
      );
    }

    window.addEventListener('click', this.showNotificationCallback);
    window.addEventListener('touchstart', this.showNotificationCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.showNotificationCallback);
    window.removeEventListener('touchstart', this.showNotificationCallback);
    if (this.notificationsLoadIntervalId) {
      clearInterval(this.notificationsLoadIntervalId);
    }
  }

  showNotificationCallback = (event: any) => {
    const { cancelHover } = this.props;
    if (
      this.notificationRef.current &&
      !this.notificationRef.current.contains(event.target) &&
      this.state.showNav
    ) {
      this.setState({ showNav: false }, () => {
        cancelHover(false, 'notification');
      });
    }
  };

  openNotifications = async () => {
    const { cancelHover, notifList, onDisplayed } = this.props;
    const { showNav } = this.state;
    if (showNav) {
      this.setState({ showNav: false }, () => {
        cancelHover(false, 'notification');
      });
    } else {
      doctrineAnalytics('Notification ButtonClicked');
      this.setState({ showNav: true }, () => {
        cancelHover(true, 'notification');
      });
      let lastNotifShown = 0;
      notifList.forEach(notif => {
        const id: number = +notif.id;
        if (!Number.isNaN(id) && id > lastNotifShown) {
          lastNotifShown = notif.id;
        }
      });

      try {
        await onDisplayed(lastNotifShown);
      } catch (error) {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 403
        ) {
          window.location.href = '/';
        } else {
          throw error;
        }
      }
    }
  };

  loadNotifications = async () => {
    const { onLoad } = this.props;
    if (!this.loading) {
      try {
        this.loading = true;
        await onLoad();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (
          error.response &&
          error.response.status &&
          error.response.status === 403
        ) {
          window.location.href = '/';
        } else {
          throw error;
        }
      }
    }
  };

  readNotificationContent = () => (event: Event) => {
    event.stopPropagation();
    const { cancelHover } = this.props;
    this.setState({ showNav: false }, () => cancelHover(false, 'notification'));
  };

  render() {
    const { showNav } = this.state;

    return (
      <NavItemButton
        ref={this.notificationRef}
        onClick={this.openNotifications}
        dataTestId="notif-open-list"
      >
        <div className={styles.content}>
          <NotificationMenu />
          {showNav && (
            <NotificationContent
              readNotificationContent={this.readNotificationContent}
            />
          )}
        </div>
      </NavItemButton>
    );
  }
}

export const Notification = Connect(withUser(RawNotification));
